var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"cart-widget"},[_c('icon-bag'),_vm._v(" "),(_vm.qty > 0)?_c('span',{class:[
      "cart-widget__badge",
      {
        'cart-widget__badge--blackfriday': _vm.$store.state.isBlackFriday,
        'cart-widget__badge--christmas': _vm.$store.state.isChristmas,
      } ]},[_vm._v(_vm._s(_vm.qty))]):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }